import { IonCheckbox, IonChip, IonItem, IonText } from '@ionic/react';
import { setLightness } from 'polished';
import React, { ReactNode } from 'react';
import styled from 'styled-components';

type Props = {
  children: ReactNode;
  color?: string;
  onClick: React.MouseEventHandler;
  selected: boolean;
  indent?: boolean;
  indeterminate?: boolean;
};

const Item = styled(IonItem)<{ $indent: boolean }>`
  padding-left: ${({ $indent }) => ($indent ? '20px' : 0)};
`;
const Chip = styled(IonChip)<{ $textColor: string }>`
  --color: ${({ $textColor }) => $textColor};
  --background: ${({ $textColor }) => setLightness(0.97, $textColor)};
  border-color: ${({ $textColor }) => setLightness(0.97, $textColor)};
`;

const FilterTrackItem = ({
  children,
  onClick,
  color = '',
  selected = false,
  indent = false,
  indeterminate = false,
}: Props) => {
  const handleOnClick = (e: React.MouseEvent<Element, MouseEvent>) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    onClick(e);
  };

  return (
    <Item
      $indent={indent}
      // skipcq: JS-0417
      onClick={handleOnClick}
    >
      <IonCheckbox checked={selected} indeterminate={selected && indeterminate}>
        <Chip $textColor={color} outline={indent}>
          <IonText style={{ color }}>{children}</IonText>
        </Chip>
      </IonCheckbox>
    </Item>
  );
};

export default FilterTrackItem;
